import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import Profile from '../../../Account/Profile/index';
import EmailConfirmation from '../../../Account/EmailConfimation/index';
import agentdetails from '../../../Agents/agentdetails';
import agentmodify from '../../../Agents/agentmodify';
import agentstatement from '../../../Agents/agentstatement';

export default () => (
  <Switch>
    <Route path="/account/profile" component={agentdetails} />
    <Route path="/account/statement" component={agentstatement} />
    <Route path="/account/modify" component={agentmodify} />

    <Route path="/account/email_confirmation" component={EmailConfirmation} />
  </Switch>
);
